import React, { useContext, useEffect, useState } from "react";

import { Grid, Paper, TableCell, TableRow } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  getKalibrasi,
  headCells,
  RESET_STATE_FORM_FILTER,
  statusKalibrasi,
} from "./helpers";

import {
  DatatablesFooterServerSide,
  InputCheckboxMaster,
  InputReactDatepicker,
  Loading,
  MasterButton,
  TableCellDefault,
} from "App/Component/ui";
import {
  defaultDateDisplay,
  defaultToastError,
  formatNumber,
  isNull,
} from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";
import { FreezeTable } from "components/organism";
import { STYLE_DEFAULT_TAB_FA } from "../../helpers";

const useStyles = STYLE_DEFAULT_TAB_FA;

export default function TabKalibrasi() {
  const classes = useStyles();
  const { dataKalibrasi, setDataKalibrasi, formData } = useContext(FormContext);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchData = async (
    id = formData.id,
    pages = formFilter.halaman,
    limit = formFilter.jumlah
  ) => {
    setLoading(true);
    const res = await getKalibrasi(formFilter, id, pages, limit);
    if (res.state) {
      setDataKalibrasi(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setDataKalibrasi([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetchData();
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: fetchData });

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: dataKalibrasi,
    orderByDefault: "id",
    orderByRow: ["id"],
  });
  return (
    <Paper
      className={classes.paper}
      style={{
        padding: "1rem",
        marginBottom: "1rem",
      }}
    >
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3} alignItems="center">
          <Grid item sm={4}>
            <InputReactDatepicker
              selected={formFilter.tglAwal}
              label="TANGGAL"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                  tglAkhir: new Date(e),
                })
              }
              withPeriode={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "1px solid #EAEAEA",
                  background: "#fff",
                  padding: "0 0.8rem 0 0.8rem",
                  cursor: "pointer",
                  // borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                s/d
              </button>
              <InputReactDatepicker
                selected={formFilter.tglAkhir}
                label=""
                minDate={new Date(formFilter.tglAwal)}
                handleChangeToday={(e) =>
                  setFormFilter({
                    ...formFilter,
                    tglAkhir: e,
                  })
                }
                onChange={(e) =>
                  setFormFilter({
                    ...formFilter,
                    tglAkhir: e,
                  })
                }
                withParentPeriode={true}
              />
            </InputReactDatepicker>
            <div
                style={{
                  cursor: "pointer",
                  // marginTop: "-1.7rem",
                  // position: "absolute",
                  // left: "2rem",
                }}
              >
                <InputCheckboxMaster
                  checked={formFilter.tgl_aktif}
                  name="tgl_aktif"
                  id="tgl_aktif"
                  label="Dengan Tanggal"
                  onChange={() =>
                    setFormFilter({
                      ...formFilter,
                      tgl_aktif: !formFilter.tgl_aktif,
                    })
                  }
                />
              </div>
          </Grid>
          <Grid item sm={2}>
            <MasterButton
              name={"CARI"}
              outline={true}
              color={"green"}
              onClick={handleSubmit}
              type={"submit"}
              size={"md"}
            />
          </Grid>
        </Grid>
        <br />
      </form>

      <Loading show={loading} />
      <FreezeTable
        headCells={headCells}
        handleRequestSort={handleRequestSort}
        order={order}
        length={length}
        orderBy={orderBy}
      >
        {stableSort(dataKalibrasi, getComparator(order, orderBy)).map(
          (row, index) => {
            return (
              <TableRow hover key={index}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="left">{row?.id}</TableCell>
                <TableCell align="left">
                  {isNull(row?.fixasset_id) ? "-" : row?.fixasset_id}
                </TableCell>
                <TableCell align="left">
                  {statusKalibrasi(row?.status)}
                </TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.tanggal)}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.nama_vendor) ? "-" : row?.nama_vendor}
                </TableCell>
                <TableCell align="right">{formatNumber(row?.harga)}</TableCell>
                <TableCell align="left">
                  {isNull(row?.remark) ? "-" : row?.remark}
                </TableCell>
                <TableCellDefault type={"custom"} row={row} />
              </TableRow>
            );
          }
        )}
      </FreezeTable>
      <DatatablesFooterServerSide
        totalData={totalData}
        pagination={pagination}
        handleChangeLimit={handleChangeLimit}
        onPrevious={onPrevious}
        onNext={onNext}
        currentPage={pagination.page}
        handleClickPageNumber={handleClickPageNumber}
      />
    </Paper>
  );
}
